import { useCallback } from "react";
import { isBoolean } from "lodash";
import useOnClickOutside from "use-onclickoutside";

type PossibleEvent = MouseEvent | TouchEvent;
type Handler = (event: PossibleEvent) => void;

export default function useOnClickOutsideWithOptions(
  ref: React.RefObject<HTMLElement>,
  handler: Handler,
  visible?: boolean
) {
  const handlerWhenVisible = useCallback(
    (event: PossibleEvent) => {
      if ((!isBoolean(visible) || visible) && handler) {
        handler(event);
      }
    },
    [visible, handler]
  );
  useOnClickOutside(ref, handlerWhenVisible);
}
